import { z } from 'zod';
import { schemas } from '../../generated/api-client';
import { TypedApiClient } from '../index';
import { apiPath } from '../path';

// ====== Import schemas from generated code (ATL-450) ======
// The hand-written ChecklistResponseSchema declared snake_case keys
// (firestore_id/store_id/checklist_type/organization_id/created_at) while the
// backend transformChecklist returns camelCase, so every declared field was
// always undefined. Use the generated camelCase response + create schemas.
export const ChecklistResponseSchema = schemas.ChecklistFirestoreResponse;
export const CreateChecklistSchema = schemas.CreateChecklistDto;

export const UpdateChecklistSchema = z.object({
  content: z.array(z.record(z.unknown())).optional(),
  checklistType: z.string().optional(),
}).passthrough();

// Type exports
export type ChecklistResponse = z.infer<typeof ChecklistResponseSchema>;
export type CreateChecklist = z.infer<typeof CreateChecklistSchema>;
export type UpdateChecklist = z.infer<typeof UpdateChecklistSchema>;

// API factory function
export function createChecklistsApi(client: TypedApiClient) {
  return {
    getChecklists: (params?: {
      storeId?: string;
      checklistType?: string;
    }): Promise<ChecklistResponse[]> => {
      return client.get('/checklists', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(ChecklistResponseSchema),
      });
    },

    createChecklist: (data: CreateChecklist): Promise<ChecklistResponse> => {
      CreateChecklistSchema.parse(data);
      return client.post('/checklists', {
        data,
        responseSchema: ChecklistResponseSchema,
      });
    },

    updateChecklist: (id: string, data: UpdateChecklist): Promise<ChecklistResponse> => {
      return client.put(apiPath`/checklists/${id}`, {
        data,
        responseSchema: ChecklistResponseSchema,
      });
    },
  };
}
